//@ts-ignore
import { ensureLuxonDate, ensureLuxonDateOnly, dateOnlyFormatPicker, getDateFromMui } from "lib/Formatters";
import React from "react";
// @ts-ignore
import { DateTime } from 'luxon';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TextField } from '@mui/material';
//@ts-ignore
import { convertToLocalTime } from "lib/DateRuleSetFormatter";
import { useMyTimezone } from 'components/customer/orgs/MyOrgAPIEndpoints';

export interface UcDatePickerFormikProps {
    dateOnly: boolean;
    defaultValue?: any;
    field: {
        name: string;
        value: any;
    };
    sendValueToForm?: Function;
    form?: {
        setFieldValue: Function;
    };
    dataCyId?: string;
    calendarMonthOnly?: boolean;
}

export const UcDatePickerFormik = (props: UcDatePickerFormikProps) => {
    const timezone = useMyTimezone();
    const { dateOnly, defaultValue, field, sendValueToForm, form, dataCyId, calendarMonthOnly } = props;

    // Initialize date from field value or default
    const initialDate = field?.value ? DateTime.fromJSDate(new Date(field.value)) : DateTime.fromJSDate(new Date(defaultValue));

    const [date, setDate] = React.useState(initialDate);

    const handleChangeDate = (value: any) => {
        let newDate = null;
        if (dateOnly) {
            newDate = ensureLuxonDateOnly(convertToLocalTime(getDateFromMui(value), timezone) ?? DateTime.fromJSDate(new Date(defaultValue)));
        }
        else {
            newDate = ensureLuxonDate(convertToLocalTime(getDateFromMui(value), timezone) ?? DateTime.fromJSDate(new Date(defaultValue)));
        }
        setDate(newDate);
        if (form) {
            form.setFieldValue(field?.name, newDate);
        }
        if (sendValueToForm) {
            sendValueToForm(newDate);
        }
    };

    React.useEffect(() => {
        if (sendValueToForm !== undefined) {
            sendValueToForm(date);
        }
    }, [date, sendValueToForm]);

    const dateValue = field?.value ? DateTime.fromJSDate(new Date(field.value)) : null;
    if (dateValue && dateValue > DateTime.utc(2092, 1, 1)) {
        field.value = DateTime.now().toJSDate();
        handleChangeDate(field?.value);
    }

    return (
        <LocalizationProvider
            dateAdapter={AdapterLuxon}
            dateFormats={{ monthAndYear: calendarMonthOnly ? 'MMMM' : 'MMMM yyyy' }}
        >
            <DatePicker
                format={dateOnlyFormatPicker}
                {...props}
                value={dateValue}
                onChange={handleChangeDate}
                slots={{
                    textField: TextField
                }}
                slotProps={{
                    textField: (params: any) => ({
                        ...params,
                        "data-cy-id": dataCyId,
                        inputProps: { ...params.inputProps, readOnly: false }
                    })
                }}
            />
        </LocalizationProvider>
    );
};